var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{staticClass:"jump-btn",class:{
    'up': _setup.scrollDirection === -1,
    'down': _setup.scrollDirection === 1,
    hidden: _setup.hidden,
    isAtTop: _setup.isAtTop,
    isAtBottom: _setup.isAtBottom,
  },attrs:{"variant":"primary"},on:{"click":_setup.clickHandler}},[_c('i',{staticClass:"fas fa-angle-double-down"})])
}
var staticRenderFns = []

export { render, staticRenderFns }